import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  IMAGE: {
    name: 'image',
    label: 'Background image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);
